
import HomeView from './src/HomeView.vue' //首页组件
import HomeView2 from './src/HomeView2.vue' //首页组件 ,带任务中心
import NavView from './src/NavView.vue'


let views = {
    HomeView,
    HomeView2,
    NavView
};

export default views;